import consumerProductsEn from './locales/en-CA/epDevpConsumerProducts.json';
import consumerProductsFr from './locales/fr-CA/epDevpConsumerProducts.json';
import consumerAppsEn from './locales/en-CA/epDevpConsumerApps.json';
import consumerAppsFr from './locales/fr-CA/epDevpConsumerApps.json';
import manageAppsEn from './locales/en-CA/epDevpManageApps.json';
import manageAppsFr from './locales/fr-CA/epDevpManageApps.json';
import appsReactEn from './locales/en-CA/epDevpAppsReact.json';
import appsReactFr from './locales/fr-CA/epDevpAppsReact.json';
import commonEn from './locales/en-CA/epDevpCommon.json';
import commonFr from './locales/fr-CA/epDevpCommon.json';

type Resource = Record<string, unknown>;

const merge = (base: Resource, override: Resource): Resource => {
  const result: Resource = { ...base };
  Object.entries(override).forEach(([key, value]) => {
    const current = result[key];
    result[key] =
      current &&
      value &&
      typeof current === 'object' &&
      typeof value === 'object' &&
      !Array.isArray(current) &&
      !Array.isArray(value)
        ? merge(current as Resource, value as Resource)
        : value;
  });
  return result;
};

const language = (value: string): 'en' | 'fr' =>
  value.toLowerCase().startsWith('fr') ? 'fr' : 'en';

const resource = (
  namespace: string,
  en: Resource,
  fr: Resource,
  includeAppsReact = false,
) => ({
  Namespace: namespace,
  getResourceBundle: (value: string): Resource => {
    const selected = language(value);
    const feature = selected === 'fr' ? fr : en;
    if (!includeAppsReact) return feature;
    return merge(selected === 'fr' ? appsReactFr : appsReactEn, feature);
  },
});

export const epDevpConsumerProductsResources = resource(
  'ep-devp-consumer-products',
  consumerProductsEn,
  consumerProductsFr,
);

export const epDevpConsumerAppsResources = resource(
  'ep-devp-consumer-apps',
  consumerAppsEn,
  consumerAppsFr,
  true,
);

export const epDevpManageAppsResources = resource(
  'ep-devp-manage-apps',
  manageAppsEn,
  manageAppsFr,
  true,
);

export const epDevpCommonResources = {
  Namespace: 'common',
  getResourceBundle: (value: string): Resource =>
    language(value) === 'fr' ? commonFr : commonEn,
};
